import { Outlet } from "react-router-dom";
import { isFeatureEnabled, FeatureFlags } from "../core/config/featureFlags";
import { cn } from "@utils/cn";
import { useTitle } from "../core/context/TitleContext";

const Header = () => {
  const { title } = useTitle();

  return (
    <header className="w-full border-b border-neutral py-3 bg-white dark:bg-gray-800 dark:border-gray-700">
      <div className="container px-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold dark:text-white">{title}</h1>
      </div>
    </header>
  );
};

export const DashboardLayout = () => {
  const useNeumorphism = isFeatureEnabled(FeatureFlags.USE_NEUMORPHISM);

  return (
    <div className={cn(
      "flex flex-col h-full min-h-0",
      "bg-[#f8f9fb] dark:bg-gray-900"
    )}>
      <Header />
      <main className="flex-1 overflow-hidden p-2 min-h-0 bg-[#f8f9fb] dark:bg-gray-900">
        <div className={cn(
          "p-6 rounded-xs h-full overflow-auto",
          useNeumorphism
            ? "container-neumorph"
            : "bg-white dark:bg-gray-800 shadow max-w-screen-xl mx-auto"
        )}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};
